import { render, staticRenderFns } from "./WxRegister.vue?vue&type=template&id=77125e99&scoped=true"
import script from "./WxRegister.vue?vue&type=script&lang=js"
export * from "./WxRegister.vue?vue&type=script&lang=js"
import style0 from "./WxRegister.vue?vue&type=style&index=0&id=77125e99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77125e99",
  null
  
)

export default component.exports